<template>
  <div id="init-home-container" class="mt-3 d-flex" style="width: 100%">
    <!--//@*/*
    //    *BUS Dice Cars  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <v-spacer></v-spacer>
    <v-main>
      <v-container
        class="cmpbk black--text"
        id="home-container"
        style="max-width: 768px"
      >
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <!-- Add Entry -->
            <h3 class="white--text">Panel to Generate New Dice Cards</h3>
            <v-card elevation="2">
              <v-card-actions>
                <v-btn color="primary" elevation="2" @click="roll3d6"
                  >To Hit3d6</v-btn
                >
                <v-btn color="primary" elevation="2" @click="printToHitCards"
                  >Print To Hit</v-btn
                >
                <v-btn color="primary" elevation="2" @click="halflocCards"
                  >Half Loc Cards</v-btn
                >
                <v-btn
                  color="primary"
                  elevation="2"
                  @click="show_full_loc_desc_now"
                  >Full Loc Desc</v-btn
                >
                <v-btn color="primary" elevation="2" @click="everydi_go"
                  >Every Di Cards</v-btn
                >
              </v-card-actions>
              <v-card-actions>
                <v-btn color="primary" elevation="2" @click="goAtkmtx"
                  >Attack Matrix</v-btn
                >
                <!-- <v-btn color="primary" elevation="2" @click="goAtkmtx3"
                  >Attack Matrix 3 Parts</v-btn
                > -->
                <v-btn color="primary" elevation="2" @click="goDefmtrx"
                  >Defense Matrix</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="show_tohit">
        <tohitcards :all3x3d6Rolls="all3x3d6Rolls"></tohitcards>
      </v-container>
      <v-container v-if="show_each3d6">
        <tohitcards :all3x3d6RollsEach="all3x3d6RollsEach"></tohitcards>
      </v-container>
      <v-container v-if="all_loc_rolls.length > 0">
        <loc_cards :all_loc_rolls="all_loc_rolls"></loc_cards>
      </v-container>
      <v-container>
        <loc_full_cards_desc v-if="show_half"></loc_full_cards_desc>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100vw;
    max-width: 100vw;
    height: auto;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

/* 768 media q *
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
const tohitcards = () => import("./tohitcards.vue");
const each3d6 = () => import("./everydi.vue");
const loc_cards = () => import("./half_loc_cards.vue");
const half_loc_cards = () => import("../components/half_loc_cards.vue");
const loc_full_cards_desc = () =>
  import("../components/loc_full_cards_desc.vue");
//loc_cards
import print from "print-js";
// import xtabs from "./xtabs.vue";
//import auth from "./auth.vue";
//import addedit_diag from "./addedit_diag.vue";
//const add_edit = () => import("./add_edit.vue");

export default {
  name: "Home",
  components: { tohitcards, half_loc_cards, loc_full_cards_desc },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      show_each3d6: false,
      show_full_loc_desc: false,
      show_tohit: false,
      aroll: [],
      stuff: [],
      roll3d6_total: 0,
      all3x3d6Rolls: [],
      all_loc_rolls: [],
      rol_loc_total: [],
      all3x3d6RollsEach: [],
      show_fulllocatins: false,
      show_half: false,
    };
  },
  watch: {
    // "$store.state.user": function () {
    //   //keep this
    //   let self = this;
    //   this.init();
    // },
  },
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    everydi_go() {
      this.$router.push("/everydi");
    },
    show_full_loc_desc_now() {
      this.$router.push("/full_loc");
    },

    goAtkmtx3() {
      this.$router.push("/atkmtrx_3part");
    },
    goAtkmtx() {
      this.$router.push("/atkmtrx");
    },
    goDefmtrx() {
      this.$router.push("/defmtrx");
    },
    printToHitCards() {
      this.mrbreakpoint();
      printJS({
        printable: "to_hit_cards_id",
        type: "HTML",
      });
    },
    download() {
      console.log("downlaod");
      var text = document.getElementById("to_hit_cards_id").innerHTML;
      var filename = "tohit.text";
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    halflocCards() {
      console.log("half");
      this.$router.push("/half_loc_cards");
    },
    roll3d6: function () {
      this.all3x3d6Rolls = [];
      this.roll3d6_total = 0;
      var r = this.$rndx;

      this.aroll = [];

      var lmts = { c18: 0, c3: 0 };
      for (let i = 0; i < 120; i++) {
        var a3x = {
          tohit: 0,
          penatrate: 0,
          damage: 0,
          count: 0,
        };

        var roll1 = r.dice(6, 3);
        var val = 0;
        for (var j = 0; j < roll1.length; j++) {
          val = val + roll1[j];
        }
        val = this.stronger(val, lmts);
        a3x.tohit = val;

        var roll2 = r.dice(6, 3);
        var val = 0;
        for (var k = 0; k < roll2.length; k++) {
          val = val + roll2[k];
        }
        val = this.stronger(val, lmts);
        a3x.penatrate = val;

        var roll3 = r.dice(6, 3);
        var val = 0;
        for (var l = 0; l < roll3.length; l++) {
          val = val + roll3[l];
        }
        val = this.stronger(val, lmts);
        a3x.damage = val;

        a3x.count = i + 1;

        this.all3x3d6Rolls.push(a3x);

        this.roll3d6_total += val;

        console.log(this.all3x3d6Rolls[i].tohit);
        this.show_tohit = true;
      }

      // this.modal_response_show = true;

      // //all rolls completed
      // this.rspns.unshift(newRspns);
    },
    all3x3d6Rolls_Each: function () {
      this.all3x3d6RollsEach = [];
      this.roll3d6_total = 0;
      var r = this.$rndx;

      this.aroll = [];

      var lmts = { c18: 0, c3: 0 };
      for (let i = 0; i < 120; i++) {
        var a3x = {
          tohit: 0,
          penatrate: 0,
          damage: 0,
          count: 0,
        };
        var eachDi = [];
        var roll1 = r.dice(6, 3);
        var val = 0;
        for (var j = 0; j < roll1.length; j++) {
          val = val + roll1[j];
        }
        val = this.stronger(val, lmts);
        a3x.tohit = val;
        eachDi.push(val);

        var roll2 = r.dice(6, 3);
        var val = 0;
        for (var k = 0; k < roll2.length; k++) {
          val = val + roll2[k];
        }
        val = this.stronger(val, lmts);
        eachDi.push(val);
        a3x.penatrate = val;

        var roll3 = r.dice(6, 3);
        var val = 0;
        for (var l = 0; l < roll3.length; l++) {
          val = val + roll3[l];
        }
        val = this.stronger(val, lmts);
        eachDi.push(val);
        a3x.damage = val;

        a3x.count = i + 1;

        this.all3x3d6Rolls.push(i, eachDi);

        // this.show_tohit = true;
      }

      // this.modal_response_show = true;

      // //all rolls completed
      // this.rspns.unshift(newRspns);
    },
    stronger(v, lmts) {
      if (v == 17 && lmts.c18 < 4) {
        lmts.c18 += 1;
        return 18;
      }
      if (v == 4 && lmts.c3 < 4) {
        lmts.c3 += 1;
        return 3;
      }
      if (v == 18) {
        lmts.c18 += 1;
      }
      if (v == 3) {
        lmts.c3 += 1;
      }
      return v;
    },
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },

    init(self) {
      this.show_loader(false);
      this.all3x3d6Rolls_Each();
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
